/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { costCalculatorPostRequestSchema } from './costCalculatorPostRequestSchema.ts';
import { costCalculatorPostResponseSchema } from './costCalculatorPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postCostCalculator200Schema = z.lazy(() => costCalculatorPostResponseSchema);

/**
 * @description 505 response
 */
export const postCostCalculator505Schema = z.any();

export const postCostCalculatorMutationRequestSchema = z.lazy(() => costCalculatorPostRequestSchema);

export const postCostCalculatorMutationResponseSchema = z.lazy(() => postCostCalculator200Schema);
